<template>
  <div class="s4-response-container">
    <!-- Conditionally render components based on the decision query param -->
    <ResponseStatusPage 
      v-if="decision === 'approved' || decision === 'rejected'" 
      :decision="decision" 
      :request-id="requestId" 
      :approverId="approverId"
      :token="token"
    />
  </div>
</template>

<script>
import ResponseStatusPage from './components/ResponseStatusPage.vue';

export default {
  name: 'Response',
  components: {
    ResponseStatusPage,
  },
  data() {
    return {
      requestId: null,
      decision: null,
      approverId: null,
      token: null,
    };
  },
  created() {
    // Read query parameters
    this.requestId = this.$route.query.request_id;
    this.decision = this.$route.query.decision.toLowerCase() === 'approve' ? 'approved' : 'rejected';
    this.approverId = this.$route.query.doctorId;
    // Signed link token: authorises the calls below without a session.
    // A repeated ?token= param arrives as an array; use the first value.
    const { token, ...rest } = this.$route.query;
    this.token = (Array.isArray(token) ? token[0] : token) || null;
    // Keep the token out of the address bar so page-URL capture
    // (analytics, session replay, error reporting) never sees it.
    if (token) this.$router.replace({ query: rest }).catch(() => {});
  },

};
</script>

<style scoped>
/* Add any container styles here if needed */
</style> 